
import listings from '~/pages/_state/events-tomorrow/index.vue'
export default listings
